export default __webpack_public_path__ + "static/media/slider5.a7d30dd7.jpg";